import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { APIService } from './../api/api.service';
//import * as $ from 'jquery';
//import * as moment from 'moment';
declare let window: any;
declare let echarts: any;

@Component({
  //moduleId: module.id.toString(),
  templateUrl: './index.component.html',
})
export class DashIndexComponent implements OnInit {
  uid = localStorage.getItem('t');
  t = localStorage.getItem('t');

  colors = [
    '#5470c6',
    '#91cc75',
    '#fac858',
    '#ee6666',
    '#73c0de',
    '#3ba272',
    '#fc8452',
    '#9a60b4',
    '#ea7ccc',
  ];
  gradientColor = ['#f6efa6', '#d88273', '#bf444c'];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiServer: APIService
  ) {}

  ngOnInit() {
    //this.graph();
    //this.weeklySalesInit();
    //this.totalOrderInit();
    //this.marketShareInit();
    //this.totalSalesInit();

    this.g1();
    this.g2();
  }

  g1() {
    var chartDom = document.getElementById('echartFunel');
    var myChart = echarts.init(chartDom);
    var option;

    option = {
      colorBy: 'series',
      color: this.colors,
      gradientColor: this.gradientColor,
      title: {
        text: 'Funnel',
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c}%',
      },
      toolbox: {
        feature: {
          dataView: { readOnly: false },
          restore: {},
          saveAsImage: {},
        },
      },
      legend: {
        data: ['Show', 'Click', 'Visit', 'Inquiry', 'Order'],
      },
      series: [
        {
          name: 'Expected',
          type: 'funnel',
          left: '10%',
          width: '80%',
          label: {
            formatter: '{b}Expected',
          },
          labelLine: {
            show: false,
          },
          itemStyle: {
            opacity: 0.7,
          },
          emphasis: {
            label: {
              position: 'inside',
              formatter: '{b}Expected: {c}%',
            },
          },
          data: [
            { value: 60, name: 'Visit' },
            { value: 40, name: 'Inquiry' },
            { value: 20, name: 'Order' },
            { value: 80, name: 'Click' },
            { value: 100, name: 'Show' },
          ],
        },
        {
          name: 'Actual',
          type: 'funnel',
          left: '10%',
          width: '80%',
          maxSize: '80%',
          label: {
            position: 'inside',
            formatter: '{c}%',
            color: '#fff',
          },
          itemStyle: {
            opacity: 0.5,
            borderColor: '#fff',
            borderWidth: 2,
          },
          emphasis: {
            label: {
              position: 'inside',
              formatter: '{b}Actual: {c}%',
            },
          },
          data: [
            { value: 30, name: 'Visit' },
            { value: 10, name: 'Inquiry' },
            { value: 5, name: 'Order' },
            { value: 50, name: 'Click' },
            { value: 80, name: 'Show' },
          ],
          // Ensure outer shape will not be over inner shape when hover.
          z: 100,
        },
      ],
    };

    myChart.setOption(option);
  }

  g2() {
    var chartDom = document.getElementById('echartWatter');
    var myChart = echarts.init(chartDom);
    var option;

    option = {
      colorBy: 'series',
      color: this.colors,
      gradientColor: this.gradientColor,
      title: {
        text: 'Accumulated Waterfall Chart',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        formatter: function (params: any) {
          let tar;
          if (params[1].value !== '-') {
            tar = params[1];
          } else {
            tar = params[0];
          }
          return tar.name + '<br/>' + tar.seriesName + ' : ' + tar.value;
        },
      },
      legend: {
        data: ['Expenses', 'Income'],
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        data: (function () {
          let list = [];
          for (let i = 1; i <= 11; i++) {
            list.push('Nov ' + i);
          }
          return list;
        })(),
      },
      yAxis: {
        type: 'value',
      },
      series: [
        {
          name: 'Placeholder',
          type: 'bar',
          stack: 'Total',
          itemStyle: {
            borderColor: 'transparent',
            color: 'transparent',
          },
          emphasis: {
            itemStyle: {
              borderColor: 'transparent',
              color: 'transparent',
            },
          },
          data: [0, 900, 1245, 1530, 1376, 1376, 1511, 1689, 1856, 1495, 1292],
        },
        {
          name: 'Income',
          type: 'bar',
          stack: 'Total',
          label: {
            show: true,
            position: 'top',
          },
          data: [900, 345, 393, '-', '-', 135, 178, 286, '-', '-', '-'],
        },
        {
          name: 'Expenses',
          type: 'bar',
          stack: 'Total',
          label: {
            show: true,
            position: 'bottom',
          },
          data: ['-', '-', '-', 108, 154, '-', '-', '-', 119, 361, 203],
        },
      ],
    };

    option && myChart.setOption(option);
  }

  //graph() {

  //  var ECHART_CANDLE_CHART = '.echart-candle-chart';
  //  var ECHART_ZOOM_IN = "[data-zoom='in']";
  //  var ECHART_ZOOM_OUT = "[data-zoom='out']";
  //  var $echartsCandleChart = document.querySelector(ECHART_CANDLE_CHART);

  //  if ($echartsCandleChart) {
  //    var userOptions = utils.getData($echartsCandleChart, 'options');
  //    var chart = window.echarts.init($echartsCandleChart);
  //    var $echartsZoomIn = document.getElementById($echartsCandleChart.dataset.actionTarget).querySelector(ECHART_ZOOM_IN);
  //    var $echartsZoomOut = document.getElementById($echartsCandleChart.dataset.actionTarget).querySelector(ECHART_ZOOM_OUT);

  //    var _utils$getColors = utils.getColors(),
  //      warning = _utils$getColors.warning;

  //    var _utils$getColors2 = utils.getColors(),
  //      primary = _utils$getColors2.primary;

  //    var splitData = function splitData(rawData) {
  //      var categoryData = [];
  //      var values = [];
  //      rawData.forEach(function (item) {
  //        categoryData.push(item.splice(0, 1)[0]);
  //        values.push(item);
  //      });
  //      return {
  //        categoryData: categoryData,
  //        values: values
  //      };
  //    };

  //    var data = splitData([['2013/1/24', 2320.26, 2320.26, 2287.3, 2362.94], ['2013/1/25', 2300, 2291.3, 2288.26, 2308.38], ['2013/1/28', 2295.35, 2346.5, 2295.35, 2346.92], ['2013/1/29', 2347.22, 2358.98, 2337.35, 2363.8], ['2013/1/30', 2360.75, 2382.48, 2347.89, 2383.76], ['2013/1/31', 2383.43, 2385.42, 2371.23, 2391.82], ['2013/2/1', 2377.41, 2419.02, 2369.57, 2421.15], ['2013/2/4', 2425.92, 2428.15, 2417.58, 2440.38], ['2013/2/5', 2411, 2433.13, 2403.3, 2437.42], ['2013/2/6', 2432.68, 2434.48, 2427.7, 2441.73], ['2013/2/7', 2430.69, 2418.53, 2394.22, 2433.89], ['2013/2/8', 2416.62, 2432.4, 2414.4, 2443.03], ['2013/2/18', 2441.91, 2421.56, 2415.43, 2444.8], ['2013/2/19', 2420.26, 2382.91, 2373.53, 2427.07], ['2013/2/20', 2383.49, 2397.18, 2370.61, 2397.94], ['2013/2/21', 2378.82, 2325.95, 2309.17, 2378.82], ['2013/2/22', 2322.94, 2314.16, 2308.76, 2330.88], ['2013/2/25', 2320.62, 2325.82, 2315.01, 2338.78], ['2013/2/26', 2313.74, 2293.34, 2289.89, 2340.71], ['2013/2/27', 2297.77, 2313.22, 2292.03, 2324.63], ['2013/2/28', 2322.32, 2365.59, 2308.92, 2366.16], ['2013/3/1', 2364.54, 2359.51, 2330.86, 2369.65], ['2013/3/4', 2332.08, 2273.4, 2259.25, 2333.54], ['2013/3/5', 2274.81, 2326.31, 2270.1, 2328.14], ['2013/3/6', 2333.61, 2347.18, 2321.6, 2351.44], ['2013/3/7', 2340.44, 2324.29, 2304.27, 2352.02], ['2013/3/8', 2326.42, 2318.61, 2314.59, 2333.67], ['2013/3/11', 2314.68, 2310.59, 2296.58, 2320.96], ['2013/3/12', 2309.16, 2286.6, 2264.83, 2333.29], ['2013/3/13', 2282.17, 2263.97, 2253.25, 2286.33], ['2013/3/14', 2255.77, 2270.28, 2253.31, 2276.22], ['2013/3/15', 2269.31, 2278.4, 2250, 2312.08], ['2013/3/18', 2267.29, 2240.02, 2239.21, 2276.05], ['2013/3/19', 2244.26, 2257.43, 2232.02, 2261.31], ['2013/3/20', 2257.74, 2317.37, 2257.42, 2317.86], ['2013/3/21', 2318.21, 2324.24, 2311.6, 2330.81], ['2013/3/22', 2321.4, 2328.28, 2314.97, 2332], ['2013/3/25', 2334.74, 2326.72, 2319.91, 2344.89], ['2013/3/26', 2318.58, 2297.67, 2281.12, 2319.99], ['2013/3/27', 2299.38, 2301.26, 2289, 2323.48], ['2013/3/28', 2273.55, 2236.3, 2232.91, 2273.55], ['2013/3/29', 2238.49, 2236.62, 2228.81, 2246.87], ['2013/4/1', 2229.46, 2234.4, 2227.31, 2243.95], ['2013/4/2', 2234.9, 2227.74, 2220.44, 2253.42], ['2013/4/3', 2232.69, 2225.29, 2217.25, 2241.34], ['2013/4/8', 2196.24, 2211.59, 2180.67, 2212.59], ['2013/4/9', 2215.47, 2225.77, 2215.47, 2234.73], ['2013/4/10', 2224.93, 2226.13, 2212.56, 2233.04], ['2013/4/11', 2236.98, 2219.55, 2217.26, 2242.48], ['2013/4/12', 2218.09, 2206.78, 2204.44, 2226.26]]);
  //    var zoomStart = 0;
  //    var zoomEnd = 70;

  //    var getDefaultOptions = function getDefaultOptions() {
  //      return {
  //        tooltip: {
  //          trigger: 'axis',
  //          // axisPointer: {
  //          //   type: "cross",
  //          // },
  //          padding: [7, 10],
  //          backgroundColor: utils.getGrays()['100'],
  //          borderColor: utils.getGrays()['300'],
  //          textStyle: {
  //            color: utils.getColors().dark
  //          },
  //          borderWidth: 1,
  //          position: function position(pos, params, dom, rect, size) {
  //            return getPosition(pos, params, dom, rect, size);
  //          }
  //        },
  //        xAxis: {
  //          type: 'category',
  //          data: data.categoryData,
  //          scale: true,
  //          splitLine: {
  //            show: false
  //          },
  //          splitNumber: 10,
  //          min: 'dataMin',
  //          max: 'dataMax',
  //          boundaryGap: true,
  //          axisPointer: {
  //            lineStyle: {
  //              color: utils.getGrays()['300'],
  //              type: 'dashed'
  //            }
  //          },
  //          axisLine: {
  //            lineStyle: {
  //              color: utils.getGrays()['300'],
  //              type: 'solid'
  //            }
  //          },
  //          axisTick: {
  //            show: false
  //          },
  //          axisLabel: {
  //            color: utils.getGrays()['600'],
  //            formatter: function formatter(value) {
  //              return new Date(value).toLocaleString('en-US', {
  //                month: 'short',
  //                day: 'numeric'
  //              });
  //            },
  //            margin: 15,
  //            fontWeight: 500
  //          }
  //        },
  //        yAxis: {
  //          scale: true,
  //          position: 'right',
  //          axisPointer: {
  //            show: false
  //          },
  //          splitLine: {
  //            lineStyle: {
  //              color: utils.getGrays()['200'],
  //              type: 'dashed'
  //            }
  //          },
  //          boundaryGap: false,
  //          axisLabel: {
  //            show: true,
  //            color: utils.getGrays()['600'],
  //            margin: 15,
  //            fontWeight: 500
  //          },
  //          axisTick: {
  //            show: false
  //          },
  //          axisLine: {
  //            show: false
  //          }
  //        },
  //        dataZoom: [{
  //          type: 'inside',
  //          start: zoomStart,
  //          end: zoomEnd
  //        }],
  //        series: [{
  //          name: 'candlestick',
  //          type: 'candlestick',
  //          data: data.values,
  //          itemStyle: {
  //            color: warning,
  //            color0: primary,
  //            borderColor: warning,
  //            borderColor0: primary
  //          }
  //        }],
  //        grid: {
  //          right: '70px',
  //          left: '20px',
  //          bottom: '15%',
  //          top: '20px'
  //        }
  //      };
  //    };

  //    echartSetOption(chart, userOptions, getDefaultOptions);

  //    var dispatchZoomAction = function dispatchZoomAction() {
  //      chart.dispatchAction({
  //        type: 'dataZoom',
  //        start: zoomStart,
  //        end: zoomEnd
  //      });
  //    };

  //    $echartsZoomIn.addEventListener('click', function () {
  //      if (zoomEnd > 10) {
  //        zoomEnd -= 10;
  //      }

  //      if (zoomEnd <= 10) {
  //        $echartsZoomIn.disabled = true;
  //      }

  //      if (zoomEnd > 0) {
  //        $echartsZoomOut.disabled = false;
  //        dispatchZoomAction();
  //      }
  //    });
  //    $echartsZoomOut.addEventListener('click', function () {
  //      if (zoomEnd < 100) {
  //        zoomEnd += 10;
  //      }

  //      if (zoomEnd >= 100) {
  //        $echartsZoomOut.disabled = true;
  //      }

  //      if (zoomEnd > 0) {
  //        $echartsZoomIn.disabled = false;
  //        dispatchZoomAction();
  //      }
  //    });
  //    chart.on('dataZoom', function (params) {
  //      if (params.batch) {
  //        zoomStart = params.batch[0].start;
  //        zoomEnd = params.batch[0].end;
  //      }
  //    });
  //  }
  //}

  weeklySalesInit() {
    let data = [120, 200, 150, 80, 70, 110, 120]; // Max value of data

    let yMax = Math.max.apply(Math, data);
    let dataBackground = data.map(function () {
      return yMax;
    });
    let myChart = echarts.init(
      document.querySelector('.echart-bar-weekly-sales')
    );

    // specify chart configuration item and data
    //let option = {
    //  title: {
    //    text: 'ECharts entry example'
    //  },
    //  tooltip: {},
    //  legend: {
    //    data: ['Sales']
    //  },
    //  xAxis: {
    //    data: ["shirt", "cardign", "chiffon shirt", "pants", "heels", "socks"]
    //  },
    //  yAxis: {},
    //  series: [{
    //    name: 'Sales',
    //    type: 'bar',
    //    data: [120, 200, 150, 80, 70, 110, 120]
    //  }]
    //};

    let option = {
      tooltip: {
        trigger: 'axis',
        padding: [7, 10],
        formatter: '{b1}: {c1}',
        transitionDuration: 0,
        backgroundColor: '#f9fafd',
        borderColor: '#d8e2ef',
        textStyle: {
          color: '#0b1727',
        },
        borderWidth: 1,
        //position: function position(pos, params, dom, rect, size) {
        //  return getPosition(pos, params, dom, rect, size);
        //}
      },
      xAxis: {
        type: 'category',
        data: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        boundaryGap: false,
        axisLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisPointer: {
          type: 'none',
        },
      },
      yAxis: {
        type: 'value',
        splitLine: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisPointer: {
          type: 'none',
        },
      },
      series: [
        {
          type: 'bar',
          barWidth: '5px',
          barGap: '-100%',
          itemStyle: {
            barBorderRadius: 10,
            color: '#f9fafd',
          },
          data: dataBackground,
          animation: false,
          emphasis: {
            itemStyle: {
              color: '#f9fafd',
            },
          },
        },
        {
          type: 'bar',
          barWidth: '5px',
          itemStyle: {
            barBorderRadius: 10,
            color: '#2c7be5',
          },
          data: data,
          z: 10,
          emphasis: {
            itemStyle: {
              color: '#2c7be5',
            },
          },
        },
      ],
      grid: {
        right: 5,
        left: 10,
        top: 0,
        bottom: 0,
      },
    };

    // use configuration item and data specified to show chart
    myChart.setOption(option);
  }

  totalOrderInit() {
    let ECHART_LINE_TOTAL_ORDER = '.echart-line-total-order'; //
    // ─── TOTAL ORDER CHART ──────────────────────────────────────────────────────────
    //

    let $echartLineTotalOrder = document.querySelector(ECHART_LINE_TOTAL_ORDER);

    if ($echartLineTotalOrder) {
      // Get options from data attribute
      let myChart = echarts.init($echartLineTotalOrder);
      //let chart = window.echarts.init($echartLineTotalOrder); // Default options

      let option = {
        tooltip: {
          triggerOn: 'mousemove',
          trigger: 'axis',
          padding: [7, 10],
          formatter: '{b0}: {c0}',
          backgroundColor: '#f9fafd',
          borderColor: '#d8e2ef',
          textStyle: {
            color: '#0b1727',
          },
          borderWidth: 1,
          transitionDuration: 0,
          //position: function position(pos, params, dom, rect, size) {
          //  return getPosition(pos, params, dom, rect, size);
          //}
        },
        xAxis: {
          type: 'category',
          data: ['Week 4', 'Week 5'],
          boundaryGap: false,
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#0b1727',
              type: 'dashed',
            },
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisPointer: {
            type: 'none',
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisPointer: {
            show: false,
          },
        },
        series: [
          {
            type: 'line',
            lineStyle: {
              color: '#2c7be5',
              width: 3,
            },
            itemStyle: {
              color: '#fff',
              borderColor: '#2c7be5',
              borderWidth: 2,
            },
            hoverAnimation: true,
            data: [20, 130],
            connectNulls: true,
            smooth: 0.6,
            smoothMonotone: 'x',
            symbol: 'circle',
            symbolSize: 8,
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(44, 123, 229, 0.25)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(44,123,229, 0)',
                  },
                ],
              },
            },
          },
        ],
        grid: {
          bottom: '2%',
          top: '0%',
          right: '10px',
          left: '10px',
        },
      };

      myChart.setOption(option);
    }
  }

  marketShareInit() {
    let ECHART_MARKET_SHARE = '.echart-market-share';
    let $echartMarketShare = document.querySelector(ECHART_MARKET_SHARE);

    if ($echartMarketShare) {
      let myChart = echarts.init($echartMarketShare);

      let option = {
        color: [
          '#2c7be5', //utils.getColors().primary
          '#27bcfd', // utils.getColors().info
          '#d8e2ef', // utils.getGrays()[300]
        ],
        tooltip: {
          trigger: 'item',
          padding: [7, 10],
          backgroundColor: '#f9fafd', // utils.getGrays()['100'],
          borderColor: '#d8e2ef', //utils.getGrays()['300'],
          textStyle: {
            color: '#0b1727', //utils.getColors().dark
          },
          borderWidth: 1,
          transitionDuration: 0,
          formatter: function formatter(params: {
            data: { name: string };
            percent: string;
          }) {
            return '<strong>'
              .concat(params.data.name, ':</strong> ')
              .concat(params.percent, '%');
          },
        },
        //position: function position(pos: any, params: any, dom: any, rect: any, size: any) {
        //  return getPosition(pos, params, dom, rect, size);
        //},
        legend: {
          show: false,
        },
        series: [
          {
            type: 'pie',
            radius: ['100%', '87%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            itemStyle: {
              borderWidth: 2,
              borderColor: '#fff', //utils.getColor('card-bg')
            },
            label: {
              normal: {
                show: false,
                position: 'center',
                textStyle: {
                  fontSize: '20',
                  fontWeight: '500',
                  color: '#5e6e82', //utils.getGrays()['700']
                },
              },
              emphasis: {
                show: false,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: [
              {
                value: 5300000,
                name: 'Samsung',
              },
              {
                value: 1900000,
                name: 'Huawei',
              },
              {
                value: 2000000,
                name: 'Apple',
              },
            ],
          },
        ],
      };

      myChart.setOption(option);
    }
  }

  totalSalesInit() {
    let ECHART_LINE_TOTAL_SALES = '.echart-line-total-sales';
    let SELECT_MONTH = '.select-month';
    let $echartsLineTotalSales = document.querySelector(
      ECHART_LINE_TOTAL_SALES
    );
    let months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    function getFormatter(params: any[]) {
      let _params$ = params[0],
        name = _params$.name,
        value = _params$.value;
      let date = new Date(name);
      return ''
        .concat(months[0], ' ')
        .concat(date.getDate().toString(), ', ')
        .concat(value);
    }

    if ($echartsLineTotalSales) {
      // Get options from data attribute

      let myChart = echarts.init($echartsLineTotalSales);
      let monthsnumber = [
        [60, 80, 60, 80, 65, 130, 120, 100, 30, 40, 30, 70],
        [100, 70, 80, 50, 120, 100, 130, 140, 90, 100, 40, 50],
        [80, 50, 60, 40, 60, 120, 100, 130, 60, 80, 50, 60],
        [70, 80, 100, 70, 90, 60, 80, 130, 40, 60, 50, 80],
        [90, 40, 80, 80, 100, 140, 100, 130, 90, 60, 70, 50],
        [80, 60, 80, 60, 40, 100, 120, 100, 30, 40, 30, 70],
        [20, 40, 20, 50, 70, 60, 110, 80, 90, 30, 50, 50],
        [60, 70, 30, 40, 80, 140, 80, 140, 120, 130, 100, 110],
        [90, 90, 40, 60, 40, 110, 90, 110, 60, 80, 60, 70],
        [50, 80, 50, 80, 50, 80, 120, 80, 50, 120, 110, 110],
        [60, 90, 60, 70, 40, 70, 100, 140, 30, 40, 30, 70],
        [20, 40, 20, 50, 30, 80, 120, 100, 30, 40, 30, 70],
      ];

      let option = {
        color: '#f9fafd', //utils.getGrays()['100'],
        tooltip: {
          trigger: 'axis',
          padding: [7, 10],
          backgroundColor: '#f9fafd', //utils.getGrays()['100'],
          borderColor: '#d8e2ef', //utils.getGrays()['300'],
          textStyle: {
            color: '#0b1727',
          },
          borderWidth: 1,
          formatter: function formatter(params: any) {
            return getFormatter(params);
          },
          transitionDuration: 0,
          //position: function position(pos: any, params: any, dom: any, rect: any, size: any) {
          //  return getPosition(pos, params, dom, rect, size);
          //}
        },
        xAxis: {
          type: 'category',
          data: [
            '2019-01-05',
            '2019-01-06',
            '2019-01-07',
            '2019-01-08',
            '2019-01-09',
            '2019-01-10',
            '2019-01-11',
            '2019-01-12',
            '2019-01-13',
            '2019-01-14',
            '2019-01-15',
            '2019-01-16',
          ],
          boundaryGap: false,
          axisPointer: {
            lineStyle: {
              color: '#d8e2ef',
              type: 'dashed',
            },
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              // color: utils.getGrays()['300'],
              color: 'rgba(0,0,0, 0.01)', //utils.rgbaColor('#000', 0.01),
              type: 'dashed',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#b6c1d2', //utils.getGrays()['400'],
            formatter: function formatter(value: string | number | Date) {
              let date = new Date(value);
              return ''
                .concat(months[date.getMonth()], ' ')
                .concat(date.getDate().toString());
            },
            margin: 15,
          },
        },
        yAxis: {
          type: 'value',
          axisPointer: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: '#d8e2ef',
              type: 'dashed',
            },
          },
          boundaryGap: false,
          axisLabel: {
            show: true,
            color: '#b6c1d2', //utils.getGrays()['400'],
            margin: 15,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            type: 'line',
            data: monthsnumber[0],
            lineStyle: {
              color: '#2c7be5',
            },
            itemStyle: {
              borderColor: '#2c7be5',
              borderWidth: 2,
            },
            symbol: 'circle',
            symbolSize: 10,
            smooth: false,
            hoverAnimation: true,
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(44,123,229, 0.2)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(44,123,229, 0)',
                  },
                ],
              },
            },
          },
        ],
        grid: {
          right: '28px',
          left: '40px',
          bottom: '15%',
          top: '5%',
        },
      };

      myChart.setOption(option);

      // Change chart options accordiong to the selected month

      let monthSelect = document.querySelector(SELECT_MONTH);

      if (monthSelect) {
        monthSelect.addEventListener('change', function (e) {
          let month = parseInt((<HTMLInputElement>e.currentTarget).value);
          let data = monthsnumber[month];
          myChart.setOption({
            tooltip: {
              formatter: function formatter(params: any[]) {
                let _params$2 = params[0],
                  name = _params$2.name,
                  value = _params$2.value;
                let date = new Date(name);
                return ''
                  .concat(months[month], ' ')
                  .concat(date.getDate().toString(), ', ')
                  .concat(value);
              },
            },
            xAxis: {
              axisLabel: {
                formatter: function formatter(value: string | number | Date) {
                  let date = new Date(value);
                  return ''
                    .concat(months[month], ' ')
                    .concat(date.getDate().toString());
                },
                margin: 15,
              },
            },
            series: [
              {
                data: data,
              },
            ],
          });
        });
      }
    }
  }

  showoptions(elemId: string) {
    let v = <HTMLElement>document.getElementById(elemId);
    console.log(v.style.display);
    if (v && v.style.display != 'block') {
      v.style.display = 'block';
    } else {
      v.style.display = 'none';
    }
  }
}
